<template>
  <el-menu class="navbar">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <levelbar></levelbar>
    <!-- <tabs-view></tabs-view> -->
    <a class="doc" :href="tzUrl" download></a>
    <a v-if="downloadUrl" class="downLink" :href="downloadUrl" download>操作说明</a>
    <!-- <span v-if=" userInfo.userTp != 'empty'" style="margin-right:9px;" class="userName" :title="userInfo.userName">{{userInfo.userName}}</span> -->
    <span style="margin-right: 32px" :title="userInfo.userName" class="userName">{{ userInfo.userName }}</span>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <!-- <img class="user-avatar" :src="avatar"> -->
        <!-- 登出 -->

        <img class="userHome" :src="img_main" alt="" />

        <!-- <i class="el-icon-caret-bottom"></i> -->
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item> 首页 </el-dropdown-item>
        </router-link>
        <span @click="logout" style="display: block"><el-dropdown-item divided>退出</el-dropdown-item></span>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Levelbar from "./Levelbar";
import TabsView from "./TabsView";
import img_main from "@/assets/images/main.png";
import Hamburger from "@/components/Hamburger";

export default {
  components: {
    Levelbar,
    Hamburger,
    TabsView,
  },
  data() {
    return {
      img_main,
      downloadUrl: "",
      tzUrl: "",
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "userInfo"]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
  },
  created: function () {
    let roles = this.$store.getters.roles;
    let roleType = "";
    for (let i = 0; i < roles.length; i++) {
      if (roles[i]["key"] == "audio_press" || roles[i]["key"] == "elect_press") {
        roleType = 1;
        break;
      } else if (roles[i]["key"] == "successive_press") {
        roleType = 2;
        break;
      }
    }
    if (roleType == 1) {
      //   this.downloadUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=0031&token=' + encodeURIComponent(this.$store.getters.token);
      // this.downloadUrl = process.env.URL_FILE + "/drmb/czsm_cbdw_yxdz.docx";
      this.downloadUrl =
        process.env.URL_FILE + "/drmb/%E5%87%BA%E7%89%88%E5%8D%95%E4%BD%8D%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C.docx";
    } else if (roleType == 2) {
      //   this.downloadUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=0032&token=' + encodeURIComponent(this.$store.getters.token);
      this.downloadUrl = process.env.URL_FILE + "/drmb/czsm_cbdw_lxdz.docx";
    }

    // this.tzUrl = process.env.BASE_API + '/Uploads/tz/tz.pdf';
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  // line-height: 50px;

  border-radius: 0px !important;
  border-bottom: solid 1px #e6e6e6;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .errLog-container {
    display: inline-block;
    position: absolute;
    right: 150px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .userName {
    float: right;
    width: 360px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    margin-top: 15px;
    font-size: 14px;
  }
  .userHome {
    height: 30px;
    margin-top: 10px;
  }
  .doc {
    float: right;
    margin-top: 15px;
    margin-right: 72px;
    font-size: 14px;
    color: #409eff;
  }
  .downLink {
    float: right;
    margin-top: 15px;
    margin-right: 24px;
    font-size: 14px;
    color: #409eff;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?1360013c